export const INCOTERM_DELETE_RESET = 'INCOTERM_DELETE_RESET'
export const INCOTERM_DELETE_SET_ERROR = 'INCOTERM_DELETE_SET_ERROR'
export const INCOTERM_DELETE_SET_DELETED = 'INCOTERM_DELETE_SET_DELETED'
export const INCOTERM_DELETE_TOGGLE_LOADING = 'INCOTERM_DELETE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/incoterm/delete/mutation_types.js